var _excluded = ["footerContent"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import Card from '../..';
import Header from './header';
import Footer from './footer';
import styles from './styles.module.scss';

var CardWithImageAndFooter = function CardWithImageAndFooter(_ref) {
  var footerContent = _ref.footerContent,
      headerProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Card, {
    className: styles.card
  }, /*#__PURE__*/React.createElement(Header, headerProps), /*#__PURE__*/React.createElement(Footer, {
    content: footerContent
  }));
};

export default CardWithImageAndFooter;